import { Button, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllRelationShip } from "../../../redux/rtk/features/masters/relationShipSlice";
import { loadSingleStaff, updateUser } from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const ContactEditPopup = ({ userId, user }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
	const { Option } = Select;
    const relationShip = useSelector((state) => state.relationShip?.list);

    // Prefill form with existing user data when modal opens
    useEffect(() => {
        if (isModalOpen) {
            form.setFieldsValue({
				email: user.email || "",
                phone: user?.phone || "",
                alternateNumber: user?.alternateNumber || "",
                emergencyContactNumber: user?.emergencyContactNumber || "",
                contactPersonName: user?.contactPersonName || "",
                contactPersonRelation: user?.contactPersonRelation || "",
            });
        }
    }, [isModalOpen, user, form]);

    useEffect(() => {
        dispatch(getAllRelationShip())
    }, []);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        try {
            const response = await dispatch(updateUser({ id: userId, values }));
            if (response.payload.message === "success") {
                dispatch(loadSingleStaff(id));
                setIsModalOpen(false);
                form.resetFields();
            }
        } catch (error) {
            console.error("Error updating contact details:", error);
        }
    };

    return (
        <>
            <button onClick={showModal}>
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Update Contact Details"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="contactDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
						label="Email"
						name="email"
						// rules={[
						// 	{ required: true, type: "email", message: "Please input a valid email!" },
						// ]}
                        >
						<Input placeholder="Email" />
					</Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[{ required: true, message: "Please enter the phone number!" }]}
                    >
                        <Input placeholder="Enter phone number" />
                    </Form.Item>

                    <Form.Item
                        label="Alternate Number"
                        name="alternateNumber"
                    >
                        <Input placeholder="Enter alternate number" />
                    </Form.Item>

                    <Form.Item
                        label="Emergency Contact Number"
                        name="emergencyContactNumber"
                    >
                        <Input placeholder="Enter emergency contact number" />
                    </Form.Item>

                    <Form.Item
                        label="Contact Person Name"
                        name="contactPersonName"
                    >
                        <Input placeholder="Enter contact person name" />
                    </Form.Item>

                    {/* <Form.Item
                        label="Contact Person Relation"
                        name="contactPersonRelation"
                    >
                        <Input placeholder="Enter relation with contact person" />
                    </Form.Item> */}

                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Contact Person Relation"
                        name="contactPersonRelation"
                    >
                        <Select
                            placeholder="Select or type relation"
                            showSearch allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {relationShip &&
                                relationShip.map((relationShip) => (
                                    <Option key={relationShip.id} value={relationShip.id}>
                                        {relationShip.relationship}
                                    </Option>
                                ))}

                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ContactEditPopup;